import { useState } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

interface AddParticipantModalProps {
  show: boolean;
  onSubmit: (username: string) => Promise<void>;
  onClose: () => void;
}

export function AddParticipantModal({ show, onSubmit, onClose }: AddParticipantModalProps) {
  const [username, setUsername] = useState('');
  const [adding, setAdding] = useState(false);

  if (!show) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim()) return;

    try {
      setAdding(true);
      await onSubmit(username);
      setUsername('');
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className="mt-4 p-3 bg-slate-900/50 rounded-lg border border-slate-700">
      <form onSubmit={handleSubmit} className="flex gap-2">
        <Input
          label="Username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username to add"
          disabled={adding}
          className="flex-1 text-sm [&_label]:sr-only"
        />
        <Button type="submit" disabled={adding || !username.trim()} variant="primary" size="sm">
          {adding ? 'Adding...' : 'Add'}
        </Button>
        <Button
          type="button"
          onClick={() => {
            onClose();
            setUsername('');
          }}
          variant="secondary"
          size="sm"
          disabled={adding}
        >
          Cancel
        </Button>
      </form>
    </div>
  );
}
